<div class="cmps-cdk-d-flex cmps-cdk-cg-0dot5">
    <div class="cmps-cdk-flex-50">
        <button
            class="cmps-button--sm cmps-cdk-bg-color-green-100 cmps-cdk-w-100pct"
            cmpsButton
            (click)="_onCallClick(_Platform.MICROSOFT)"
        >
            <cmps-icon svgIcon="phone-in-talk"></cmps-icon>
            <span cmpsButtonLabel>Call (go live)</span>
        </button>
    </div>
    <div class="cmps-cdk-flex-50">
        <button
            class="cmps-button--sm cmps-cdk-w-100pct"
            cmpsButton
            (click)="_onCallClick(_Platform.LOCAL)"
        >
            <cmps-icon svgIcon="microphone"></cmps-icon>
            <span cmpsButtonLabel>Side-by-Side</span>
        </button>
    </div>
</div>
